import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		<div class="poem">
			<p class="poem-block mb-3">
				Ноябрь … начинает свой бег.
			</p>
			
			<p class="poem-block mb-3">
				По серому небу, по чёрным деревьям, по осколкам солнца, затоптанным в жидкую грязь; между жёлтых стен, потемневших от влаги, 
				по пустым переулкам, по гулким крышам…
			</p>
			
			<p class="poem-block mb-3">
				Ноябрь, месяц предсмертия и смерти, тихого и бессильного засыпания, сдачи всех позиций, отказа и ухода. 
				Впереди – долгая зима и смерть.
			</p>
			
			<p class="poem-block mb-3">
				И кто же поверит, что потом будет весна? 
			</p>
			
			<p class="poem-block mb-3">
			 	Ноябрь… только начинает свой бег. 
			</p>
		</div>
		`
	)
}

const itemName = {
	rus: "Ноябрь"
}

const itemDate = {
	rus: "13 ноября 2025"
}
const itemLink = "Ноябрь";

const item = {
	itemlink: getLink(itemLink),
	rus:{
		itemName: itemName.rus,
		itemDate: itemDate.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}


export default item;